module.exports = __webpack_public_path__ + "static/media/icon-card-defects.60fa7bdf.svg";